export default __webpack_public_path__ + "static/media/news.5c180c8d.png";